import { VetterJobStage } from '@codezo/graphql';
import type { StatusTone } from '../components/ui/status-badge';

/**
 * The badge tone per stage, seen from the supplier's side: their turn is
 * `warn`, work under way is `info`, waiting on others is `neutral`. The words
 * are the backend's `stageLabel`. Exhaustive, so a new stage fails the build.
 */
export const STAGE_TONE: Record<VetterJobStage, StatusTone> = {
	[VetterJobStage.AwaitingPrices]: 'warn',
	[VetterJobStage.PricesSubmitted]: 'neutral',
	[VetterJobStage.InProduction]: 'info',
	[VetterJobStage.ToShip]: 'warn',
	[VetterJobStage.Shipped]: 'success',
	[VetterJobStage.Closed]: 'neutral',
};

/** The list's tabs, as the backend doc suggests them. */
export const JOB_TABS: { value: string; label: string; stages?: VetterJobStage[] }[] = [
	{
		value: 'todo',
		label: 'To do',
		stages: [VetterJobStage.AwaitingPrices, VetterJobStage.InProduction, VetterJobStage.ToShip],
	},
	{ value: 'waiting', label: 'Waiting', stages: [VetterJobStage.PricesSubmitted] },
	{ value: 'done', label: 'Done', stages: [VetterJobStage.Shipped, VetterJobStage.Closed] },
	{ value: 'all', label: 'All' },
];
